import { useEffect, useMemo, useState } from 'react';
import { Breadcrumb } from '../../Components/Atoms';
import { AddModelIcon } from '../../Assets/images/svgs';
import { Link, useNavigate } from 'react-router-dom';
import { ReactTable } from '../../Components/Molecules';
import { SHOW_VEHICLE_HEADERS } from '../../Library/tableHeaders';
import { getFilters } from '../../Library/tableHelpers';
import { Button } from '@chakra-ui/react';
import { getVehiclesInfo } from '../../APIs';
import PATH from '../../Routes/paths';
import './style.css';

const ShowVehicles = () => {
  const Navigate = useNavigate();
  const [data, setData] = useState([])

  const columns = useMemo(() =>
    Object.values(SHOW_VEHICLE_HEADERS).map(header => {
      return {
        Header: header.nm,
        accessor: header.key,
        disableSortBy: !header.sorting,
        ...getFilters(header),
        Cell: (row) => {
          return (row.column.id === "reg") ? <Link to={`${row.cell.row.original.idx}`} className='show-vehicle-reg-col'>{row.value || '-'}</Link> : (row.value || '-');
        },
      };
    }), []);

  const fetchVehicles = () => {
    getVehiclesInfo(null, null, (err, resp) => {
      if (err) console.error("ShowVehicles : Error while fetching all vehicles", err);
      else {
        setData(resp);
      }
    })
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  const breadcrumbPaths = [
    { idx: 1, name: "Inventory Management", link: PATH.INVENTORY },
    { idx: 1, name: "Vehicles", link: "", isCurrentPage: true },
  ];
  
  return (
    <div className="panel-main show-vehicle-main">
      <div>
        <Breadcrumb paths={breadcrumbPaths} />
      </div>

      <div className='show-vehicle-section'>
        <Button
          leftIcon={<AddModelIcon />}
          className="add-new-vehicle"
          onClick={() => Navigate("addVehicle")}
        >
          Add New Vehicle
        </Button>

        <div className='show-vehicle-table overflow-table'>
          <ReactTable
            heading={"Vehicles"}
            columns={columns}
            data={data}
            showSearch={true}
            pageSize={6}
          />
        </div>
      </div>
    </div>
  )
}

export default ShowVehicles;